import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/theme-vars.scss'
import './styles/index.scss'
import './styles/element-theme.scss'
import { loadStoredTheme } from '@/utils/applyTheme'

Vue.use(ElementUI)
Vue.config.productionTip = false

loadStoredTheme()

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
